module.exports = __webpack_public_path__ + "teqbahn-assets/media/4.5c7796bc.jpg";